import { invert as invert$1 } from '../../object/invert.mjs';

function invert(obj) {
    return invert$1(obj);
}

export { invert };
